import React, { useEffect, useRef, useState } from 'react'
import Slider from 'react-slick'
import SliderWrapper from './ikimBannerSlickSlider.js'
import EditMenu from '../editMenu'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { isEmpty } from 'lodash'
import { withTheme } from 'theming'
import AddSection from '../addSection'
import CustomImage from '../../customImage/customImage'
import useTemplateHook from '../templateHook'
import PassimPlayer from '../rosemary/passimPlayer'

const IkimBanner = ({
  componentData,
  modifyData,
  setModalState,
  isEdit,
  onSwap,
  onDelete,
  onCopy,
  theme,
  onAdd,
}) => {
  const sliderRef = useRef(null)
  const { data, id, config } = componentData
  const [hoverState, setHoverState] = useState('')
  const [setting, setSetting] = useState({})
  const { customNavigate, getTemplateImage, PrevArrowIkim, NextArrowIkim } = useTemplateHook()
  const [currentSlideNumber, setCurrentSLideNumber] = useState(0)

  const handleHoverItems = (name) => {
    if (!isEdit) return
    setHoverState(name)
  }

  const handleModal = () => {
    setModalState({
      keyID: id,
      modalData: data,
    })
  }

  const handleAddModal = () => {
    onAdd({
      keyID: id,
      modalData: data,
    })
  }

  const handleRedirect = (linkObj) => {
    customNavigate('INDIRECT', linkObj, isEdit)
  }

  function SampleNextArrow(props) {
    const { className, style, onClick, transform } = props
    return (
      <div
        className={className}
        style={{
          ...style,
          display: 'block',
          background: 'transparent',
          width: '24px',
          height: '32px',
          position: 'absolute',
          top: '50%',
          right: '0px',
          transform: `translateX(-${transform}px) translateY(-50%)`,
          content: `url(${NextArrowIkim})`,
        }}
        onClick={onClick}
      >
        NextArrow
      </div>
    )
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick, transform } = props
    return (
      <div
        className={className}
        style={{
          ...style,
          display: 'block',
          background: 'transparent',
          width: '24px',
          height: '32px',
          position: 'absolute',
          top: '50%',
          left: '0px',
          transform: `translateX(${transform}px) translateY(-50%)`,
          content: `url(${PrevArrowIkim})`,
          zIndex: '10',
        }}
        onClick={onClick}
      >
        PrevArrow
      </div>
    )
  }
  useEffect(() => {
    setSetting({
      dots: true,
      autoplay: data?.auto_slide,
      autoplaySpeed: 2500,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      pauseOnHover: true,
      adaptiveHeight: true,
      nextArrow: <SampleNextArrow transform={28} />,
      prevArrow: <SamplePrevArrow transform={28} />,
      appendDots: (dots) => {
        return (
          <div
            style={{
              backgroundColor: 'transparent',
              borderRadius: '0px',
              paddingTop: 'max(1.5vw, 15px)',
              paddingBottom: 'max(1.5vw, 15px)',
              bottom: '0',
            }}
          >
            <ul>
              {dots.map((info, idx) => (
                <li key={idx} className={`${info.props.className}`}>
                  <div
                    style={{
                      backgroundColor: `${
                        info.props.className === 'slick-active'
                          ? getStyleValue('dots_color', 'active_color', `#ffffff`)
                          : getStyleValue('dots_color', 'inactive_color', '#ffffff')
                      }`,
                      opacity: 1,
                    }}
                    className="ft-slick__dots--custom"
                    onClick={info.props.children.props.onClick}
                  >
                    <div className="" />
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )
      },
      customPaging: (i) => (
        <div className="ft-slick__dots--custom">
          <div className="" />
        </div>
      ),
      responsive: [
        {
          breakpoint: 1536,
          settings: {
            nextArrow: <SampleNextArrow transform={28} />,
            prevArrow: <SamplePrevArrow transform={28} />,
          },
        },
        {
          breakpoint: 1280,
          settings: {
            nextArrow: <SampleNextArrow transform={28} />,
            prevArrow: <SamplePrevArrow transform={28} />,
          },
        },
        {
          breakpoint: 768,
          settings: {
            nextArrow: <SampleNextArrow transform={28} />,
            prevArrow: <SamplePrevArrow transform={28} />,
          },
        },
        {
          breakpoint: 640,
          settings: {
            arrows: false,
          },
        },
      ],
      afterChange: (current) => {
        setCurrentSLideNumber(current)
      },
    })

    const sliderElement = sliderRef.current

    if (sliderElement) {
      if (data?.auto_slide) {
        sliderElement.slickPlay()
      } else {
        sliderElement.slickPause()
      }
    }
  }, [data, theme])

  const getStyleValue = (parentKey, childKey, defaultValue) => {
    if (!data?.style_config) {
      return defaultValue ? defaultValue : ''
    }

    let tempArr = data?.style_config[parentKey]?.data.filter((info) => info.key === childKey)

    return !isEmpty(tempArr) ? (tempArr[0].value ? tempArr[0].value : defaultValue) : defaultValue
  }

  return (
    <div
      className={` w-full relative  ${isEdit && hoverState && 'component-hover-class'} `}
      onMouseOver={() => handleHoverItems(`TOP`)}
      onMouseLeave={() => handleHoverItems('')}
      style={{ background: getStyleValue('component_background', 'primary_color', theme.c1) }}
    >
      {isEdit && hoverState.length > 0 && (
        <EditMenu
          onDelete={() => onDelete(id)}
          onMoveUp={() => onSwap(id, 'up')}
          onMoveDown={() => onSwap(id, 'down')}
          onEdit={() => handleModal()}
          onCopy={() => onCopy(id)}
        />
      )}
      {!isEmpty(setting) && (
        <SliderWrapper
          className="h-full"
          gradientColor={getStyleValue('component_background', 'primary_color', '#000000')}
          isBannerHover={hoverState.length ? true : false}
        >
          <Slider ref={sliderRef} {...setting} className="h-full">
            {data?.slide_data.map((slide, idx) => (
              <div
                key={idx}
                // className={`2xl:h-[80vh] lg:h-[70vh] md:h-[60vh] sm:h-[40vh] h-[175px]`}
                className={` w-full h-full`}
              >
                <div
                  className={`relative flex flex-col w-full h-full ${
                    config[slide.content.position]
                  } `}
                >
                  {!isEdit && slide?.player?.type && idx === currentSlideNumber ? (
                    <div className="absolute w-full h-full">
                      <PassimPlayer
                        data={slide?.player}
                        poster={getTemplateImage(slide?.image_s3key)}
                        controlBar={false}
                        isBanner={true}
                        iconPositionClass={
                          slide.content.position === 'TOP_RIGHT'
                            ? 'decomposed-banner-player-icon-left'
                            : 'decomposed-banner-player-icon'
                        }
                        onClickRedirect={() => handleRedirect(slide.link)}
                      />
                    </div>
                  ) : (
                    <CustomImage
                      imageUrl={getTemplateImage(slide?.image_s3key)}
                      imgClass="absolute w-full h-full"
                      loaderClass="w-full h-full absolute -z-10"
                      loaderStyle={{
                        background: '#5A5A5A50',
                      }}
                      imgAlt={'category'}
                      onClickRedirect={() => handleRedirect(slide.link)}
                    />
                  )}
                  <div className="  lg:w-1/2 flex justify-center items-center px-4 lg:px-0 py-4 lg:py-14 xl:mb-6">
                    <div
                      className={`w-full lg:w-[78.5%] flex flex-col ${
                        config[slide.content.position]
                      } z-10 `}
                    >
                      {slide.content.heading_type === 'HEADING' ? (
                        <h1
                          style={{
                            color: getStyleValue('heading', 'color', '#F9AF2E'),
                            fontFamily: getStyleValue('heading', 'font', ''),
                            textAlign: getStyleValue('heading', 'alignment', ''),
                          }}
                          className={`text-xl md:text-2xl lg:text-4xl xl:text-[40px]   ${getStyleValue(
                            'heading',
                            'font_format',
                            'font-bold',
                          )} line-clamp-3 mb-0`}
                        >
                          {slide.content.heading}
                        </h1>
                      ) : (
                        <div
                          className={`h-[68px] xl:h-[160px] aspect-[${slide?.content?.logo_aspect_ratio}]`}
                        >
                          <CustomImage
                            imageUrl={getTemplateImage(slide.content.logo_s3key)}
                            imgClass="w-full h-full"
                            loaderClass="w-full h-full"
                            loaderStyle={{
                              background: '#5A5A5A50',
                            }}
                            imgAlt={'logo_s3key'}
                          />
                        </div>
                      )}

                      <h3
                        style={{
                          color: getStyleValue('sub_heading', 'color', '#F9AF2E'),
                          fontFamily: getStyleValue('sub_heading', 'font', ''),
                          textAlign: getStyleValue('sub_heading', 'alignment', ''),
                        }}
                        className={` font-normal hidden lg:block ${getStyleValue(
                          'sub_heading',
                          'font_format',
                          '',
                        )} text-base mb-0 mt-4`}
                      >
                        {slide.content.sub_heading}
                      </h3>
                      {slide?.cta_button?.enabled && (
                        <button
                          style={{
                            backgroundImage: `linear-gradient(to ${getStyleValue(
                              'button',
                              'gradient',
                              'left',
                            )}, ${getStyleValue(
                              'button',
                              'primary_color',
                              theme.c2,
                            )}, ${getStyleValue('button', 'secondary_color', theme.c2)})`,
                            color: getStyleValue('button', 'text_color', '#fff'),
                            borderRadius: '6px',
                          }}
                          className={`border-0 py-2 px-6  text-xs md:text-lg mt-4 lg:mt-6 mb-3 xl:mb-0`}
                          onClick={() => handleRedirect(slide.link)}
                        >
                          {slide.cta_button.text}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </SliderWrapper>
      )}

      {isEdit && hoverState.length > 0 && <AddSection openAdd={handleAddModal} />}
    </div>
  )
}

export default withTheme(IkimBanner)
